export const routes = {
    ROOT: '/*',
    LOGIN: '/login',
    CONTAINER: '/container',
    API_LIST: '/container/render_UI'
};
